import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { listUsers } from '../../actions/userActions';
import { ListProducts } from '../../actions/productAction';
import { orderNow } from '../../actions/orderActions';
import Axios from '../../axios/axios';

export default function EditOrder() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const userList = useSelector((state) => state.userList);
  const { loading, error, users } = userList;

  const productList = useSelector((state) => state.productList);
  const { products } = productList;

  const orderNow_ = useSelector((state) => state.orderNow);
  const { success } = orderNow_;

  const [customer, setCustomer] = useState('');
  const [product, setProduct] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [availability, setAvailability] = useState('');
  const [searchCustomer, setSearchCustomer] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);

  const [advance, setAdvance] = useState(0);

  const [searchCustomerLoading, setCustomerLoading] = useState(false);
  const [searchCustomerRes, setResCustomer] = useState('');
  const [searchCustomerCode, setResCustomerCode] = useState('');

  const [order, setOrder] = useState();

  const today = new Date().toISOString().split('T')[0]

  useEffect(() => {
    getOrder();
    dispatch(listUsers(''));
    dispatch(ListProducts({ pagination: false }));
  }, [dispatch]);

  const getOrder = async () => {
    await Axios.get(`/api/order/${id}`).then((res) => {
      setOrder(res.data);
    });
  };

  useEffect(() => {
    if (!customer) {
      setCustomer(order?.user?._id);
      setResCustomer(order?.user?.name);
      setSearchCustomer(order?.user?.phone1);
      setSelectedItems(order?.orderItems);
      setAdvance(order?.advance);
    }
  }, [order]);

  const onSubmit = async (e) => {
    e.preventDefault();

    const data = {
      customer,
      product,
      startDate,
      endDate,
    };
    await Axios.post(`/api/order/check`, data).then((res) => {
      if (res.data.code === 200) {
        setAvailability(res.data.code);

        const newArray = [...selectedItems];
        newArray.push({ product, startDate, endDate });
        setSelectedItems(newArray);
      } else {
        setAvailability(res.data.code);
      }
    });
  };

  const productName = (proId) => {
    let data = products?.filter((data) => data._id === proId);

    return data?.[0]?.name;
  };

  const removeItems = (index) => {
    if (window.confirm('Do you want remove item')) {
      const newArray = [...selectedItems];
      newArray.splice(index, 1);
      setSelectedItems(newArray);
    }
  };

  const totalAmount = () => {
    let totalAmount_ = 0;
    selectedItems?.map((data) => {
      let proId = data.product;

      let product_ = products?.filter((data_) => data_._id === proId);

      // find how mach days
      const date1 = new Date(data.startDate);
      const date2 = new Date(data.endDate);

      const timeDiff = Math.abs(date2 - date1);

      const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

      let days = daysDiff === 0 ? daysDiff + 1 : daysDiff;

      let price = product_ && product_[0].price * days;

      totalAmount_ = totalAmount_ + price;
    });
    return totalAmount_;
  };


  const bookNow = async (e) => {
    e.preventDefault();

    let data = {
      id,
      customer,
      selectedItems,
      advance,
      orderAmount: totalAmount(),
    };

    await Axios.put(`/api/order/`, data).then((res) => {
      if (res.status === 200) {
        window.location.href = '/orders';
      }
    });
  };

  const calculateBalance = () => {
    let bal = totalAmount() - advance;

    return bal;
  };

  const customerSearchFunction = async () => {
    if (searchCustomer === '') {
      setResCustomer('Please enter mobile number');
    } else {
      setCustomerLoading(true);
      const { data } = await Axios.get(`/api/user/mob/${searchCustomer}`);

      setResCustomerCode(data.code);

      if (data.code === 400) {
        setCustomerLoading(false);
        setResCustomer(data.message);
      } else {
        setCustomerLoading(false);
        setResCustomer(data.user.name);
        setCustomer(data.user._id);
      }
    }
  };

  return (
    <div>
      {' '}
      <div>
        <form onSubmit={onSubmit}>
          <div class="row">
            <div class="col-md-6 grid-margin stretch-card">
              <div class="card tale-bg">
                <div class="card-people mt-auto">
                  <img
                    src={process.env.PUBLIC_URL + '/images/people.png'}
                    alt="people"
                  />
                  <div class="weather-info">
                    <div class="d-flex">
                      <div class="ml-2">
                        <h4 class="location font-weight-normal">Order Now</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 grid-margin transparent">
              <div class="row">
                <div class="col-md-6 mb-4 stretch-card transparent">
                  <div class="card card-tale">
                    <div class="card-body">
                      <p class="mb-4">Customer</p>

                      <div class="d-flex">
                        <div class="p-2">
                          {' '}
                          <input
                            type="search"
                            className="form-control"
                            placeholder="Search number here"
                            onChange={(e) => setSearchCustomer(e.target.value)}
                            value={searchCustomer}
                            disabled
                          />
                        </div>
                        {/* <div class="p-2">
                          <i
                            className="icon-search mx-0 pointer"
                            onClick={customerSearchFunction}
                          ></i>
                        </div> */}
                      </div>
                      <div>
                        {searchCustomerLoading === true ? (
                          <div class="spinner-border ml-5" role="status">
                            <span class="sr-only ">Loading...</span>
                          </div>
                        ) : (
                          <span>
                            {' '}
                            {searchCustomerRes}{' '}
                            {searchCustomerCode === 400 && (
                              <Link to="/user/create">Create customer </Link>
                            )}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-4 stretch-card transparent">
                  <div class="card card-dark-blue">
                    <div class="card-body">
                      <p class="mb-4">Total Price</p>
                      <p class="fs-30 mb-2">
                        {selectedItems?.length === 0 ? 0 : totalAmount()}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 mb-4 stretch-card transparent">
                  <div class="card card-tale">
                    <div class="card-body">
                      <p class="mb-4">Select Product</p>
                      <select
                        className="form-control"
                        required
                        value={product}
                        onChange={(e) => setProduct(e.target.value)}
                      >
                        <option value="">Select Product</option>
                        {products?.map((data) => (
                          <option value={data._id}>{data.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 mb-4 stretch-card transparent">
                  <div class="card card-tale">
                    <div class="card-body">
                      <p class="mb-4">Start Date</p>
                      <input
                        type="date"
                        className="form-control"
                        required
                        value={startDate}
                        min={today}

                        onChange={(e) => setStartDate(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-4 mb-4 stretch-card transparent">
                  <div class="card card-tale">
                    <div class="card-body">
                      <p class="mb-4">End Date</p>
                      <input
                        type="date"
                        className="form-control"
                        required
                        value={endDate}
                        min={today}

                        onChange={(e) => setEndDate(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-secondary btn-lg btn-block"
                >
                  Search Availability
                  <i class="ti-search float-right"></i>
                </button>
                {availability === 200 && (
                  <div
                    class="alert alert-success alert-dismissible fade show mt-2"
                    role="alert"
                  >
                    <strong>Item Added!</strong> Items available for this date
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                )}
                {availability === 400 && (
                  <div
                    class="alert alert-Danger alert-dismissible fade show mt-2"
                    role="alert"
                  >
                    <strong>Not Available!</strong> Items not available for this
                    date
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                <p class="card-title">Selected Items</p>
                <div class="row">
                  <div class="col-10">
                    <div class="table-responsive">
                      <table
                        class="display expandable-table"
                        style={{ width: '100%' }}
                      >
                        <thead>
                          <tr>
                            <th>Number</th>
                            <th>Product</th>
                            <th>Start Date</th>
                            <th>End Date</th>

                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedItems?.map((data, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{productName(data.product)}</td>
                              <td>{data.startDate}</td>
                              <td>{data.endDate}</td>
                              <td>
                                {' '}
                                <i
                                  class="mdi mdi-close-octagon-outline"
                                  style={{ color: 'red' }}
                                  onClick={(e) => removeItems(index)}
                                ></i>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-2">
                    <label>Advance</label>
                    <input
                      type="number"
                      className="form-control mb-2"
                      placeholder="Advance Amount"
                      value={advance}
                      min={0}
                      onChange={(e) => setAdvance(e.target.value)}
                    />
                    <div> Balance : {calculateBalance()}</div>
                    <button
                      type="button"
                      class="btn btn-success mt-2"
                      data-toggle="modal"
                      data-target="#exampleModal"
                      disabled={selectedItems?.length === 0 ? true : false}
                    >
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        backdrop={true}
        data-backdrop="static"
      >
        {' '}
        <form class="forms-sample">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  Summary
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="table-responsive">
                  <table class="table table-striped table-borderless">
                    <thead>
                      <tr>
                        {' '}
                        <th>Sl No</th>
                        <th>Items</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedItems?.map((data, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{productName(data.product)}</td>
                          <td>{data.startDate}</td>
                          <td>{data.endDate}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="mt-4">
                  Total Price : ₹
                  {selectedItems?.length === 0 ? 0 : totalAmount()}
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" class="btn btn-primary" onClick={bookNow}>
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
